<template>
  <div v-loading="fullscreenLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
    <el-form
      :label-position="left"
      :inline="true"
      size="mini"
      label-width="80px"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-row>
        <el-form-item label="菜品名称">
          <el-input v-model="formInline.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="销售分类">
          <el-select clearable v-model="formInline.cateId" placeholder="请选择">
            <el-option value label="全部"></el-option>
            <el-option
              v-for="item in selectList"
              :key="item.ID"
              :label="item.NAME"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜品状态">
          <el-select clearable v-model="formInline.status">
            <el-option v-for="item in optionS" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="22" style="text-align:center">
          <el-button size="mini" type="primary" @click="search" icon="el-icon-search">搜索</el-button>
          <el-button size="mini" type="primary" @click="add" icon="el-icon-plus">添加菜品</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      size="mini"
      header-cell-class-name="cen"
      cell-class-name="cen"
      ref="multipleTable"
      :data="tableData3"
      tooltip-effect="dark"
      style="width:100%"
      :row-class-name="classCallback"
    >
      <el-table-column label="序号" type="index" :index="indexMethod" width="55px"></el-table-column>
      <el-table-column prop="picUrl" label="菜品图片" width="100px">
        <template slot-scope="scope">
          <el-popover
            popper-class="cen"
            placement="right"
            :title="scope.row.name"
            width="400"
            trigger="hover"
          >
            <img style="width:350px;height:350px;" :src="scope.row.picShowUrl" alt="加载失败" />
            <img
              slot="reference"
              style="width:80px;height:80px;cursor: pointer;"
              :src="scope.row.picShowUrl"
              alt="加载失败"
            />
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="菜品名称"></el-table-column>
      <el-table-column prop="price" label="菜品单价">
        <template slot-scope="scope">{{(scope.row.price/100).toFixed(2)}}元</template>
      </el-table-column>
      <el-table-column prop="cateName" label="销售分类"></el-table-column>
      <el-table-column prop="status" label="菜品状态">
        <template slot-scope="scope">{{scope.row.status==0?'下架':'上架'}}</template>
      </el-table-column>
      <el-table-column prop="quantity" label="每日预售数量">
         <template slot-scope="scope">{{(scope.row.quantity/100)}}</template>
      </el-table-column>
      <el-table-column prop="memo" label="菜品描述">
        <template slot-scope="scope">
          <el-popover
            popper-class="lengin"
            placement="top"
            title="备注"
            width="200"
            trigger="hover"
            :content="scope.row.memo"
          >
            <div class="memo" slot="reference">{{scope.row.memo}}</div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="sourceIp" label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="cal(scope.row)"
          >{{scope.row.status==1?'下架':'上架'}}</el-button>
          <el-button size="mini" type="primary" @click="edit(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div class="block">
      <el-pagination
        class="right"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNo"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <el-dialog :title="Title" :visible.sync="dialogFormVisible">
      <el-form
        v-loading="loading2"
        element-loading-text="正在提交..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.7)"
        size="mini"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm"
      >
        <el-form-item label="菜品名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="菜品分类" prop="cateId">
          <el-select v-model="ruleForm.cateId" placeholder="请选择菜品分类">
            <el-option
              v-for="item in selectList"
              :key="item.ID"
              :label="item.NAME"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜品图片上传" prop="pic">
          <div style="display:flex">
            <div style="line-height:0;border:1px dashed #e2e2e2;border-radius:3px;">
              <croppa
                :initial-image="initialImage"
                @image-remove="imgSet"
                :remove-button-size="20"
                :width="250"
                :placeholder-font-size="16"
                :height="250"
                placeholder="选择图像"
                v-model="croppa"
              ></croppa>
            </div>
            <div class="btn-list">
              <div>
                <el-button size="mini" @click="croppa.rotate()">旋转</el-button>
              </div>
              <div>
                <el-button size="mini" @click="croppa.zoomIn()">放大</el-button>
              </div>
              <div>
                <el-button size="mini" @click="croppa.zoomOut()">缩小</el-button>
              </div>
              <div>
                <el-button type="primary" size="mini" @click="upImg()">上传</el-button>
              </div>
            </div>
            <!-- <div class="server">
              <div class="div" title="到服务器图库选择图片" @click="serverImgSelect=true">
                <i class="el-icon-picture-outline"></i>
                图库选择
              </div>
              <div class="YY"></div>
            </div>-->
          </div>
          <div style="margin-top:10px;">仅支持JPG、GIF、PNG图片文件，且文件小于5M</div>
          <el-input type="hidden" v-model="ruleForm.pic"></el-input>
        </el-form-item>
        <el-form-item label="是否销售" prop="status">
          <el-switch :active-value="1" :inactive-value="0" v-model.number="ruleForm.status"></el-switch>
        </el-form-item>
        <el-form-item label="每日预售数量" prop="quantity">
          <el-input v-model="ruleForm.quantity"></el-input>
        </el-form-item>
        <el-form-item label="计量单位" prop="unitId">
          <el-select v-model="ruleForm.unitId" placeholder="请选择菜品分类">
            <el-option
              v-for="item in numberlist"
              :key="item.distCode"
              :label="item.distName"
              :value="item.distName"
            ></el-option>
          </el-select>
          <el-button size="mini" @click="addnumber">添加</el-button>
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input v-model="ruleForm.price">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="起订量" prop="minAmount">
          <el-input v-model="ruleForm.minAmount"></el-input>
        </el-form-item>
        <el-form-item label="菜品描述" prop="memo">
          <el-input type="textarea" v-model="ruleForm.memo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="dialogFormVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog custom-class="h90" title="图库" :visible.sync="serverImgSelect" top="20px">
      <server-img @close="serverImgSelect=false" v-if="serverImgSelect" :data="Item"></server-img>
    </el-dialog>
  </div>
</template>

<script>
import Eve from "../../../components/common/emit.js";
import { baseurl } from "../../../base.js";
import serverImg from "./serverImg.vue";
export default {
  components: { serverImg },
  created() {
    Eve.$on("categoryListChange", () => {
      this.select();
    });
    Eve.$emit("categoryListChange");
    Eve.$on("goodsList", this.load);
  },
  mounted() {
    this.load();
    this.select();
  },
  data() {
    var money = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^[0-9]{1,8}([.][0-9]{1,2})?$/;
        if (!str.test(value)) {
          callback(new Error("最大八位数字，两位小数"));
        } else {
          callback();
        }
      }
    };
    var kongge = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^\S+$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的菜品名称"));
        } else {
          callback();
        }
      }
    };
    var kongge_n = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        let str = /^\S+$/;
        if (!str.test(value)) {
          callback(new Error("不允许输入空格"));
        } else {
          callback();
        }
      }
    };
    var kongge_p = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^\S+$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的菜品单价"));
        } else {
          callback();
        }
      }
    };
    var kongge_w = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("必填项"));
      } else {
        let str = /^[1-9][0-9]{0,4}$/;
        if (!str.test(value)) {
          callback(new Error("最大输入5位整数"));
        } else {
          callback();
        }
      }
    };
    return {
      numberlist: [],
      selectList: [],
      serverImgSelect: false,
      initialImage: "",
      croppa: {},
      header: { "Access-Control-Allow-Origin": "*" },
      loading2: false,
      picImg: "",
      Title: "",
      uploadurl: baseurl + "/api/file//upload",
      dialogFormVisible: false,
      imageUrl: "",
      ruleForm: {
        price: "",
        status: "",
        memo: "",
        pic: "",
        quantity: "",
        cateId: "",
        name: "",
        unitId: "",
        minAmount: ""
      },
      rules: {
        pic: [
          {
            required: true,
            message: "请上传菜品图片",
            trigger: "change"
          }
        ],
        minAmount: [
          {
            required: true,
            message: "请输入最小起购量",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入正确的菜品名称",
            trigger: "blur"
          },
          { validator: kongge, trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "最少1位，最大10位字符",
            trigger: "blur"
          }
        ],
        unitId: [
          {
            required: true,
            message: "请选择计量单位",
            trigger: "change"
          }
        ],
        memo: [
          {
            message: "请输入菜品描述",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "最大100个字符",
            trigger: "blur"
          },
          { validator: kongge_n, trigger: "blur" }
        ],
        cateId: [
          {
            required: true,
            message: "请选择菜品分类",
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入菜品单价",
            trigger: "change"
          },
          { validator: money, trigger: "change" },
          { validator: kongge_p, trigger: "blur" }
        ],
        quantity: [
          {
            required: true,
            message: "请输入预售数量",
            trigger: "change"
          },
          { validator: kongge_w, trigger: "blur" }
        ]
      },

      formLabelWidth: "120px",
      optionS: [{ Id: 0, Name: "下架" }, { Id: 1, Name: "上架" }],
      value7: [],
      options: {
        1: "桌位管理",
        2: "销售分类",
        3: "菜品管理",
        4: "订单管理",
        5: "设置打印"
      },
      fullscreenLoading: false,
      page: {
        total: 0
      },
      left: "left",
      tableData3: [],
      formInline: {
        cateId: "",
        name: "",
        status: "",
        pageNo: 1,
        size: 10
      },
      editData: {}
    };
  },
  methods: {
    select() {
      this.$http
        .post(`/v/category/all`, {
          platCode: localStorage.getItem("platCode"),
          merId: localStorage.getItem("merId")
        })
        .then(data => {
          this.selectList = data.data;
        });
    },
    numlist() {
      this.$http
        .post(`/w/dict/list`, {
          platCode: localStorage.getItem("platCode"),
          merId: localStorage.getItem("merId")
        })
        .then(data => {
          this.numberlist = data.data;
        });
    },
    addnumber() {
      this.$prompt("计量单位", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[\u4E00-\u9FA5]{1,5}$/,
        inputErrorMessage: "最多支持五个汉字"
      })
        .then(({ value }) => {
          this.$http
            .post(`/w/dict/add`, {
              platCode: localStorage.getItem("platCode"),
              merId: localStorage.getItem("merId"),
              distName: value
            })
            .then(data => {
              this.$message({
                type: "success",
                message: "添加成功"
              });
              this.numlist();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    changeImgInit({ imgUrl, url }) {
      this.ruleForm.pic = imgUrl;
      var image = new Image();
      image.setAttribute("crossorigin", "anonymous");
      image.src = url;
      this.initialImage = image;
      this.croppa.refresh();
    },
    classCallback(obj) {
      if (obj.row.status == 0) {
        return "iS-active";
      } else {
        return "b";
      }
    },
    upImg() {
      if (!this.croppa.hasImage()) {
        this.$message.error("请选择需要上传的图片！！！");
        return;
      }
      this.croppa.generateBlob(blob => {
        var fd = new FormData();
        fd.append("uploadFile", blob, "blob.png");
        this.$http.post(this.uploadurl, fd).then(res => {
          this.$message.success("上传成功！！！");
          this.ruleForm.pic = res.data;
        });
      });
    },
    imgSet() {
      this.ruleForm.pic = "";
    },
    indexMethod(index) {
      return (this.formInline.pageNo - 1) * 10 + index + 1;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let price = this.ruleForm.price;
          this.loading2 = true;
          let url =
            this.Title == "新增菜品" ? "/w/goods/add" : "/w/goods/modify";
       
          let data = {...this.ruleForm}
             data.price = Math.round(data.price * 100);
          data.quantity = Math.round(data.quantity * 100);
          this.$http.post(url, data).then(
            data => {
              this.dialogFormVisible = false;
              this.$message.success(this.Title + "成功");
              this.load();
              this.loading2 = false;
            },
            () => {
              this.ruleForm.price = price;
              this.loading2 = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    add() {
      for (let i in this.ruleForm) {
        this.ruleForm[i] = "";
      }
      this.picImg = "";
      this.ruleForm.status = 1;
      this.Title = "新增菜品";
      this.ruleForm.quantity = "99999";
      this.dialogFormVisible = true;
      this.$refs["ruleForm"] && this.$refs["ruleForm"].resetFields();
      this.numlist();
      this.$nextTick(e => {
        this.croppa.remove();
      });
    },
    edit(obj) {
      this.Title = "修改菜品";
      this.dialogFormVisible = true;
      this.numlist();
      this.$nextTick(_=>{
        this.$refs["ruleForm"].resetFields();      
        let data = JSON.parse(JSON.stringify(obj));
      data.quantity = "" + data.quantity;
      data.price = (data.price / 100).toFixed(2);
      data.quantity=data.quantity / 100;
      var image = new Image();
      image.setAttribute("crossorigin", "anonymous");
      image.src = data.picShowUrl;
      this.initialImage = image;
      this.$nextTick(e => {
        this.croppa.refresh();
      });
      data.picUrl = null;
      this.ruleForm = data;
      })

    },
    cal(obj) {
      let data = {
        gdId: obj.id,
        status: obj.status == 1 ? 0 : 1
      };
      let str = obj.status == 1 ? "下架" : "上架";
      this.$http
        .post(`/w/goods/status/${obj.id}`, {
          status: data.status
        })
        .then(() => {
          this.$message.success(str + "成功");
          this.load();
        });
    },
    handleCurrentChange(index) {
      this.formInline.pageNo = index;
      this.load();
    },
    load() {
      this.fullscreenLoading = true;
      this.$http
        .post(
          `/w/goods/s?pageNumber=${this.formInline.pageNo}&pageSize=${this.formInline.size}`,
          this.formInline
        )
        .then(data => {
          this.fullscreenLoading = false;
          this.tableData3 = data.data;
          this.page.total = data.pageable.totalElements;
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });
    },
    search() {
      this.formInline.pageNo = 1;
      this.load();
    }
  }
};
</script>

<style scoped>
.server {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 300px;
  flex-direction: column;
}
.server > .div i {
  font-size: 30px;
}
.server > .div:hover {
  background-color: #409eff;
  box-shadow: 0 0px 10px 0 #d9dcda inset;
  color: #fff;
}
.server > .div {
  box-shadow: 0 0px 91px 1px #d9dcda inset;
  cursor: pointer;
  transition: all 0.2s;
  width: 98px;
  height: 98px;
  border-radius: 98px;
  border: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
}
.btn-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 80px;
  flex-direction: column;
  padding: 30px 0;
}
.memo {
  max-height: 70px;
  overflow: hidden;
  white-space: nowrap;
}
.img {
  width: 200px;
}
.cen {
  text-align: center;
}
.right {
  text-align: right;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 178px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/view/page/commodityAdmin/commodityAdmin.vue